import HOCWatchValue from 'components/common/hoc-watch-value';
import * as React from 'react';

import FlightItem from './items';

export default function FlightPurchaseItems() {
  const values = HOCWatchValue({ keys: ['approvalable.flightPurchases'] });

  return (
    <>
      {(values['approvalable.flightPurchases'] || []).map((item, idx) => (
        <FlightItem key={item.id} parentIndex={idx} />
      ))}
    </>
  );
}
